import React from 'react'
import { Button } from 'react-bootstrap'

const ButtonSuccess = (props) => (
    <Button style={{margin:'auto'}} className="btn btn-success py-3 px-5 text-uppercase" {...props} > { props.text } </Button>
)

export default ButtonSuccess